import { TranslationKey } from '../../../../types/translation/TranslationKey';

import moment from 'moment';
import React, { useContext, useState } from 'react';
import { translate } from '../../../../types/translation/Translator';
import { ProductTransactionExportConfigurationContext } from '../../../../context/ProductTransactionExportConfigurationContext';
import { ExportUtil } from '../../../../util/export.util';
import { ExportItems } from '../../../components/ExportItems';
import { Routing } from '../../../../util/routes.util';
import { UserContext } from '../../../../context/UserContext';
import { ProductTransactionExportConfigurationRequest } from '../../../../requests/productTransactionExportConfiguration.request';
import { useRequest } from '../../../../requests/common/requestHook';
import { User } from '../../../../types/user';
import { Button, CancelButton } from '../../../components/Button';
import { ActionModal } from '../../../components/Modal';
import { ExportFile } from '../../../../types/export/export';

interface ProductTransactionExportModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export function ProductTransactionExportModal({ open, setOpen }: ProductTransactionExportModalProps) {
  const { productTransactionExportConfigurations, productTransactionExportConfigurationsLoading } = useContext(
    ProductTransactionExportConfigurationContext,
  );

  const { currentUser } = useContext(UserContext);

  const [exportProducts, { loading }] = useRequest(ProductTransactionExportConfigurationRequest.download);

  const [selected, setSelected] = useState<Set<string>>(
    new Set(
      [...productTransactionExportConfigurations.values()].filter(config => config.default).map(config => config.id),
    ),
  );
  const [date, setDate] = useState<string | undefined>(undefined);

  const handleClose = () => {
    setOpen(false);
  };

  const handleDownload = async () => {
    const locale = User.locale(currentUser);

    if (!selected.size) {
      const file = await exportProducts({
        timezone: moment.tz.guess(),
        locale: locale,
      });
      if (!file) return;
      ExportUtil.downloadExport(file);
    } else {
      const files: ExportFile[] = [];
      for (const configId of Array.from(selected)) {
        const file = await exportProducts({
          configId,
          timezone: moment.tz.guess(),
          locale: locale,
        });
        if (file) files.push(file);
      }
      if (!files.length) return;

      if (files.length === 1) {
        ExportUtil.downloadExport(files[0]);
      } else {
        ExportUtil.downloadZip(files, productTransactionExportConfigurations);
      }
    }

    setSelected(new Set());
    handleClose();
  };

  const footer = (
    <div className='flex justify-end gap-2'>
      <CancelButton onClick={handleClose} disabled={loading} />
      <Button loading={loading} text={translate({ key: TranslationKey.export })} onClick={handleDownload} />
    </div>
  );

  return (
    <ActionModal
      footer={footer}
      title={translate({ key: TranslationKey.exportProductTransactions })}
      open={open}
      setOpen={setOpen}
      className='max-w-[720px]'
    >
      <ExportItems
        items={[...productTransactionExportConfigurations.values()]}
        selected={selected}
        setSelected={setSelected}
        createPath={Routing.stock.history.settings.report.create()}
      />
    </ActionModal>
  );
}
